var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.252,
    height: 31.25,
    viewBox: "0 0 31.252 31.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-call",
    "data-name": "Icon ionic-ios-call",
    d: "M34.839,28.972A26.25,26.25,0,0,0,29.356,25.3c-1.643-.789-2.245-.773-3.409.065-.968.7-1.595,1.351-2.709,1.106s-3.311-1.9-5.443-4.027S14,18.119,13.768,17s.415-1.741,1.106-2.709c.838-1.163.862-1.765.065-3.409A25.731,25.731,0,0,0,11.27,5.4c-1.2-1.2-1.464-.936-2.123-.7A12.083,12.083,0,0,0,7.2,5.736,5.866,5.866,0,0,0,4.868,8.2c-.464,1-1,2.864,1.733,7.729a43.126,43.126,0,0,0,7.582,10.113h0l.008.008.008.008h0a43.3,43.3,0,0,0,10.113,7.582c4.865,2.734,6.728,2.2,7.729,1.733a5.766,5.766,0,0,0,2.465-2.335,12.083,12.083,0,0,0,1.033-1.944C35.775,30.436,36.043,30.168,34.839,28.972Z",
    transform: "translate(-4.49 -4.502)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.9c65eed73ce7fbd82ac5f1e43a3a4739.svg";
export { ForwardRef as ReactComponent };